<template>
  <Modal class="residential-account-complaint" v-if="Boolean(state)" :show="true" @close="state = null">
    <Mutate v-show="state === 'mutate'" v-model="valueComp" @edit="edit" @close="state = null">
      <template #footer>
        <ButtonComponent :label="$t('cancel')" @click="state = null" :icon="['fal', 'times']" />
      </template>
    </Mutate>
    <ImageMarker v-show="state === 'edit' && currentItem" :value="currentItem" @input="replaceImage">
      <template #footer>
        <ButtonComponent :label="$t('cancel')" @click="state = 'mutate'" :icon="['fal', 'times']" />
      </template>
    </ImageMarker>
  </Modal>
</template>

<script>
import Bus from '@/bus'
import ImageMarker from './ImageMarker'
import Mutate from './Mutate'
import { ModalComponent as Modal } from 'vue-elder-modal'

export default {
  props: {
    value: {
      type: Object,
      default: () => ({}),
    },
  },
  data() {
    return {
      state: null,
      images: [],
      currentItem: null,
    }
  },
  computed: {
    valueComp: {
      get() {
        return {
          ...this.value,
          images: this.images,
        }
      },
      set(val) {
        this.images = val.images
        return val
      },
    },
  },
  methods: {
    edit(val) {
      this.state = 'edit'
      this.currentItem = val
    },
    replaceImage(newVal) {
      let oldValIndex = this.images.findIndex(i => i.url === this.currentItem.url)
      if (isNaN(oldValIndex)) return this.close()
      this.valueComp.images.splice(oldValIndex, 1, newVal)
      return (this.state = 'mutate')
    },
  },
  created() {
    Bus.$on('complaint:show', () => {
      this.state = 'mutate'
    })
  },

  components: {
    Modal,
    Mutate,
    ImageMarker,
  },
}
</script>

<style lang="scss">
.residential-account-complaint {
}
</style>
